
import React from 'react';
import { motion } from 'framer-motion';
import { protocolData } from '../data';

const Introduction = () => {
    const { introduction } = protocolData;

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.1,
                delayChildren: 0.3,
            },
        },
    };
    
    const itemVariants = {
        hidden: { y: 20, opacity: 0 },
        visible: {
            y: 0,
            opacity: 1,
        },
    };

    return (
        <motion.section 
            id="introduction" 
            className="section"
            style={{ paddingTop: '120px' }}
            variants={containerVariants}
            initial="hidden"
            animate="visible"
        >
            <motion.h1 variants={itemVariants} style={{ color: 'var(--green)', fontFamily: 'monospace', marginBottom: '1rem', fontSize: 'clamp(24px, 4vw, 36px)', lineHeight: '1.2' }}>
                {protocolData.documentTitle}
            </motion.h1>
            <motion.h2 variants={itemVariants} className="section-title" style={{ marginTop: '0', whiteSpace: 'normal' }}>
                {introduction.title}
            </motion.h2>
            <motion.p variants={itemVariants}>
                {introduction.purpose}
            </motion.p>
            <motion.div variants={itemVariants}>
                <p>The primary objectives of this protocol are:</p>
                <ul>
                    {introduction.objectives.map((obj, index) => (
                        <li key={index}>{obj}</li>
                    ))}
                </ul>
            </motion.div>
        </motion.section>
    );
};

export default Introduction;
